export function clearMap(viewer) {
  viewer.entities.removeAll()
  viewer.dataSources.removeAll()
  viewer.scene.primitives.removeAll()
  // 获取webgl上下文
  let gl = viewer.scene.context._originalGLContext
  // 当canvas大小改变时，页面就会自动刷新
  gl.canvas.width = 1
  gl.canvas.height = 1
  viewer = viewer && viewer.destroy()
  // 销毁webgl上下文
  gl.getExtension("WEBGL_lose_context").loseContext()
  gl = null
  // 销毁页面计时器
  let end = setInterval(function () { }, 10000)
  for (let i = 1; i <= end; i++) {
    clearInterval(i)
  }
}
